import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, Pressable, xcss } from '@atlaskit/primitives';

const baseStyles = xcss({
	height: '32px',
	paddingInline: 'space.150',
	width: '100%',
	borderRadius: 'radius.small',
	color: 'color.text',
	backgroundColor: 'color.background.neutral',

	':hover': {
		backgroundColor: 'color.background.neutral.hovered',
	},
});

const selectedStyles = xcss({
	backgroundColor: 'color.background.selected',
	color: 'color.text.accent.blue',

	':hover': {
		backgroundColor: 'color.background.selected.hovered',
	},
});

const buttonWrapperStyles = xcss({
	maxWidth: '280px', // matches dropdown of 312px (and padding)
});

const textStyles = xcss({
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	font: 'font.body',
	fontWeight: 'font.weight.medium',
});

interface PressableToggleFilterProps {
	autoFocus: boolean;
	icon: JSX.Element | null;
	isSelected: boolean;
	label: string;
	onClick: () => void;
}

const PressableToggleFilter = ({
	icon,
	label,
	onClick,
	isSelected,
	autoFocus,
}: PressableToggleFilterProps): React.JSX.Element => {
	return (
		<Box xcss={buttonWrapperStyles}>
			<Pressable
				onClick={onClick}
				autoFocus={autoFocus}
				xcss={[baseStyles, isSelected && selectedStyles]}
			>
				<Inline alignBlock="center" alignInline="start" xcss={textStyles} space="space.100">
					<Inline alignBlock="center" alignInline="center">
						{icon}
					</Inline>
					{label}
				</Inline>
			</Pressable>
		</Box>
	);
};

export default PressableToggleFilter;
